const isCloudApp =
  typeof window !== 'undefined' &&
  window.location.pathname.startsWith('/cloud_app/xplan-meeting-assistant');

const prefix = isCloudApp ? '/services/xplan-meeting-assistant' : '';

export const API_BASE_URL = `${prefix}/api`;
export const MASTRA_BASE_URL = `${prefix}/mastra`;
